import React from 'react';
import ReactDOM from 'react-dom';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
// depois do mdb.css de propósito: o override só vence se carregar por último
import './styles/cores-sobrias.css';
import { register as registerServiceWorker } from './registerServiceWorker';
// APP PRECISA ESTA EM BAIXO PARA UTILIZAR OS ELEMENTOS DE CIMA

import App from './App';
window.process = {}; // concertar o bug de hot reloaded , process
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
registerServiceWorker();
